import axios from 'axios';
import { handleLogout } from '../functions/logout';
import { API } from './env';

const rawAxios = axios.create();

export const axiosInstance = axios.create();

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    const isAuth = window.location.href.includes('auth');
    if (!isAuth && error.response?.status === 401) {
      const originalRequest = error.config;

      if (originalRequest._retry) {
        handleLogout();
        return Promise.reject(error);
      }

      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        handleLogout();
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await rawAxios.post(`${API}/auth/refresh`, { refreshToken });
        const { accessToken, refreshToken: newRefreshToken } = response.data;

        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
          user.token = accessToken;
          localStorage.setItem('user', JSON.stringify(user));
        }
        localStorage.setItem('refresh_token', newRefreshToken);

        originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
        processQueue(null, accessToken);
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        handleLogout();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  },
);
